<template>
  <div class="div-block-25" :class="{'client-action-handler': actionButton}">
    <div
      data-w-id="4c06adb2-2b97-ce79-91ef-5e3b3e797c81"
      class="add-prijem-btn"
      :class="{'client-action-button': actionButton}"
      role="button"
      tabindex="0"
      @click="openDebtTypePicker()"
      @keydown.enter.space.prevent="openDebtTypePicker()"
    >
      <div
        class="text-small bl-color pointer"
        :class="{'client-action-label': actionButton}"
      >
        {{ title }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ClientDebtHandler",
  props: {
    title: String,
    rules: [Array, null],
    clientInfo: [Object, null],
    type: [String, null],
    actionButton: Boolean,
  },
  methods: {
    openDebtTypePicker () {
      if (this.clientInfo) this.$store.commit("popupManagerState/setClientInfo", this.clientInfo);
      this.$store.commit("popupManagerState/pushToPopupOrder", {
        type: this.type,
        payload: null,
        component: "ClientDebtPicker",
        rules: this.rules,
      });
    },
  },
};
</script>

<style scoped></style>
